// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchForm_search__1OCcr","input":"SearchForm_input__110qi","actions":"SearchForm_actions__18FZ9","reset":"SearchForm_reset__1TFNi"};